export default {
  label: {
    title: {
      removeCards: 'Remover {count} componentes',
      removeCard: 'Remover {count} componente',
    },
    button: {
      cancel: 'Cancelar',
      remove: 'Remover',
    },
  },
};
